import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13 5a1 1 0 0 0-1 1v1a3 3 0 0 1-3 3v8h6.646a1 1 0 0 0 .928-.629l2.4-6A1 1 0 0 0 18.046 10H15a1 1 0 0 1-.949-1.316c.456-1.367.399-2.345.155-2.915C13.992 5.269 13.608 5 13 5m0-2a3 3 0 0 0-3 3v1a1 1 0 0 1-1 1H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10.646a3 3 0 0 0 2.785-1.886l2.4-6C21.62 10.144 20.168 8 18.046 8h-1.76c.196-1.127.125-2.163-.242-3.019C15.508 3.731 14.392 3 13 3M7 18v-8H5v8z",
      clipRule: "evenodd"
    }
  )
);
var SvgThumbsUpOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ThumbsUpOutlined_default = SvgThumbsUpOutlined;

export { ThumbsUpOutlined_default as default };
